// Lightweight event emitters that call into the reducer
import { applyAugments } from './reducer';

export function createAugmentEventApi(store) {
  return {
    emitMove: (unitId, from, to) => applyAugments(store, { type: 'onMove', unitId, from, to }),
    emitCapture: (attackerUnitId, victimUnitId, victimType) => applyAugments(store, { type: 'onCapture', attackerUnitId, victimUnitId, victimType }),
    emitCheck: (attackerUnitId) => applyAugments(store, { type: 'onCheck', attackerUnitId }),
    emitGameEnd: (result, deliveredByUnitId) => applyAugments(store, { type: 'onGameEnd', result, deliveredByUnitId }),
    emitSurvive: (unitId) => applyAugments(store, { type: 'onSurvive', unitId }),
    onRoundStart: () => applyAugments(store, { type: 'onRoundStart' })
  };
}


